import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FieldError from '../form/FieldError';

export default class InputBox extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    labelStyle: PropTypes.string,
    small: PropTypes.string,
    meta: PropTypes.object,
    style: PropTypes.object,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    placeholder: PropTypes.string,
  };

  render() {
    const {
      input,
      label,
      labelClassName,
      wrapperClassName,
      containerClassName,
      containerStyle,
      labelStyle,
      small,
      placeholder,
      style,
      className,
      autoFocus,
      parse,
      meta,
      ...custom
    } = this.props;

    const renderLabel = label
      ? <label className={labelClassName} style={labelStyle}>{label}</label>
      : null;

    const renderSmall = (small) ? <small className="text-muted">{small}</small> : null;
    const fieldErr = <FieldError meta={meta} />;


    return (
      <div className={wrapperClassName}>
        {renderLabel}
        <div className={containerClassName} style={containerStyle}>
          <input
            placeholder={placeholder}
            style={style}
            className={className || 'form-control'}
            autoFocus={autoFocus}
            {...input}
            {...custom}
          />
          {/*
          <Field
            name={name}
            component="input"
            placeholder={placeholder}
            style={style}
            className={className || 'form-control'}
            autoFocus={autoFocus}
            {...input}
            {...custom}
          />
          */}
          {fieldErr}
          {renderSmall}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/InputBox.js